import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon } from 'lucide-react';
import { provider } from '../data/provider';
export function Place() {
  return <main id="main" className="bg-paper" data-id="element-998" data-mp="shzjyrdpu73i">
      <div className="mx-auto max-w-shell px-6 pb-12 pt-8 lg:px-10" data-id="element-999" data-mp="sgy6kg9898im">
        <nav aria-label="Breadcrumb" data-id="element-1000" data-mp="x8fyyfx6q0rz">
          <ol className="flex flex-wrap items-center gap-2 text-[12.5px] text-muted" data-id="element-1001" data-mp="x9hk5d7x03nf">
            <li data-id="element-1002" data-mp="126r80ofno795">
              <Link to="/" className="hover:text-ink hover:underline" data-id="element-1003" data-mp="1279ba50qjlqk">
                Home
              </Link>
            </li>
            <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1004" data-mp="16b8p2fums6g8" />
            <li data-id="element-1005" data-mp="1b90jphmnu6o4">
              <Link to="/things-to-do" className="hover:text-ink hover:underline" data-id="element-1006" data-mp="1b6e7v5sql503">
                {provider.hub}
              </Link>
            </li>
            <ChevronRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1007" data-mp="3d0n7zbf63ngw" />
            <li aria-current="page" className="text-ink" data-id="element-1008" data-mp="3hyosm0s8ruuh">
              {provider.name}
            </li>
          </ol>
        </nav>

        <div className="mt-14 max-w-3xl" data-id="element-1009" data-mp="2lj6rdtirlnvm">
          <p className="label text-olive" data-id="element-1010" data-mp="2ljzu8jelrt8h">{provider.category}</p>
          <h1 className="mt-6 font-display text-[48px] font-300 leading-[0.98] text-ink sm:text-[62px]" data-id="element-1011" data-mp="2gqn7yfxebyiw">
            {provider.name}
          </h1>
          <p className="mt-7 max-w-prose text-[18px] font-300 leading-[1.7] text-ink/75" data-id="element-1012" data-mp="27qqk2gitz3ow">
            {provider.oneLiner}
          </p>
        </div>
      </div>

      <div className="mx-auto grid max-w-shell gap-16 px-6 pb-24 lg:grid-cols-[1fr_320px] lg:px-10 lg:pb-28" data-id="element-1013" data-mp="34g81ttv38g6y">
        <article className="min-w-0 max-w-prose" data-id="element-1014" data-mp="2zftr2423qs58">
          {provider.body.map(para => <p key={para.slice(0, 24)} className="mb-7 text-[17px] leading-[1.9] text-ink/80" data-id="element-1015" data-mp="2vei1fyj8a6x1">
              {para}
            </p>)}

          <section aria-labelledby="know-h" className="mt-14 border-t border-line pt-10" data-id="element-1016" data-mp="1k1pa2oucnkhi">
            <h2 id="know-h" className="label text-olive" data-id="element-1017" data-mp="1f2cm20rqs7dc">
              Good to know
            </h2>
            <ul className="mt-7 space-y-4" data-id="element-1018" data-mp="1gji4lpqpgm0r">
              {provider.goodToKnow.map(item => <li key={item} className="flex gap-4 text-[15.5px] leading-[1.75] text-ink/80" data-id="element-1019" data-mp="1li32hiihitm1">
                  <span className="mt-2.5 h-1.5 w-1.5 shrink-0 bg-olive" aria-hidden="true" data-id="element-1020" data-mp="17itx7dvthjwu" />
                  {item}
                </li>)}
            </ul>
          </section>

          <section aria-labelledby="parents-h" className="mt-16" data-id="element-1021" data-mp="xsqxkuu6x7pj">
            <h2 id="parents-h" className="label text-olive" data-id="element-1022" data-mp="xrfu6w4nq1yy">
              What local parents say
            </h2>
            <div className="mt-8 space-y-10" data-id="element-1023" data-mp="12la9zoh55wsr">
              {provider.parentNotes.map(note => <figure key={note.author} className="border-l-2 border-peach pl-7" data-id="element-1024" data-mp="nsq80r5q9vcw">
                  <blockquote className="font-display text-[25px] font-300 italic leading-[1.45] text-ink" data-id="element-1025" data-mp="stxkv4mq9kqf">
                    “{note.quote}”
                  </blockquote>
                  <figcaption className="label mt-4 text-muted" data-id="element-1026" data-mp="jro96bfq3lbg">
                    {note.author}
                  </figcaption>
                </figure>)}
            </div>
          </section>

          <aside aria-label="Sponsored message" className="mt-16 bg-foam/50 px-8 py-9" data-id="element-1027" data-mp="3rf1u0nwmy7n4">
            <p className="label text-ink/55" data-id="element-1028" data-mp="95rkh79zrl3g">Presented by this business</p>
            <h2 className="mt-4 font-display text-[28px] font-300 leading-tight text-ink" data-id="element-1029" data-mp="54pjom0ff0zd">
              Fall term registration opens September 2
            </h2>
            <p className="mt-3 max-w-lg text-[15px] leading-[1.8] text-ink/70" data-id="element-1030" data-mp="e7gymvsigevr">
              Infant through pre-K classes at both campuses. Waitlists move
              quickly in the first two weeks.
            </p>
            <a href="#next" className="label mt-7 inline-block border border-ink/30 px-7 py-3.5 text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-paper" data-id="element-1031" data-mp="nxtg2f513rxo">
              See the term dates
            </a>
          </aside>

          <section aria-labelledby="faq-h" className="mt-16" data-id="element-1032" data-mp="2regkusymgkbu">
            <h2 id="faq-h" className="font-display text-[34px] font-300 text-ink sm:text-[40px]" data-id="element-1033" data-mp="2rbuaymo9dsqg">
              Parent questions
            </h2>
            <dl className="mt-8 border-t border-line" data-id="element-1034" data-mp="315kxvn4qlv41">
              {provider.faqs.map(f => <div key={f.question} className="border-b border-line py-7" data-id="element-1035" data-mp="35764wrulbf6b">
                  <dt className="font-display text-[23px] font-400 text-ink" data-id="element-1036" data-mp="28gdr60v4pz7p">
                    {f.question}
                  </dt>
                  <dd className="mt-3 text-[15.5px] leading-[1.85] text-muted" data-id="element-1037" data-mp="2hfh931ik88km">
                    {f.answer}
                  </dd>
                </div>)}
            </dl>
          </section>
        </article>

        <aside aria-label="At a glance" className="lg:sticky lg:top-28 lg:self-start" data-id="element-1038" data-mp="3sv5ydzjadjol">
          <div className="border-t-2 border-ink pt-7" data-id="element-1039" data-mp="1o36t6zjdbdu">
            <h2 className="label text-muted" data-id="element-1040" data-mp="1miapcxkpkdv">At a glance</h2>
            <dl className="mt-7 space-y-6" data-id="element-1041" data-mp="bsjjjrhpycdf">
              {[['Ages', provider.ages], ['Cost', provider.cost], ['Where', provider.neighborhood], ['Registration', provider.registration], ['Best for', provider.bestFor]].map(([term, value]) => <div key={term} data-id="element-1042" data-mp="3u60yp7cs1fhx">
                  <dt className="label text-muted/70" data-id="element-1043" data-mp="3p6woqei13dqj">{term}</dt>
                  <dd className="mt-2 text-[15px] leading-relaxed text-ink" data-id="element-1044" data-mp="3p8hkg7g2x2pz">
                    {value}
                  </dd>
                </div>)}
            </dl>
            <p className="label mt-9 border-t border-line pt-5 text-muted/70" data-id="element-1045" data-mp="3f9s2yfs3hka9">
              {provider.updated}
            </p>
          </div>
        </aside>
      </div>

      <section id="next" aria-labelledby="next-h" className="border-t border-line bg-white" data-id="element-1046" data-mp="1dhx3cyj4568e">
        <div className="mx-auto max-w-shell px-6 py-20 lg:px-10 lg:py-24" data-id="element-1047" data-mp="19fimgjz08gjr">
          <p className="label text-olive" data-id="element-1048" data-mp="32yr8grj7c82g">Because you’re looking at this</p>
          <h2 id="next-h" className="mt-6 font-display text-[38px] font-300 leading-tight text-ink sm:text-[46px]" data-id="element-1049" data-mp="32xg2cl2aao86">
            Read next
          </h2>
          <ul className="mt-12 grid gap-x-14 gap-y-9 sm:grid-cols-2" data-id="element-1050" data-mp="2tznm9eoqncjq">
            {provider.nextSteps.map(step => <li key={step.label} className="group relative border-b border-line pb-6" data-id="element-1051" data-mp="2xxbnezh0y1k2">
                <p className="label text-muted/70" data-id="element-1052" data-mp="3ln5zhetirm39">{step.kind}</p>
                <h3 className="mt-3 font-display text-[25px] font-300 leading-tight text-ink" data-id="element-1053" data-mp="3qnaef0es48rd">
                  <Link to="/things-to-do" className="decoration-olive decoration-1 underline-offset-[7px] after:absolute after:inset-0 after:content-[''] group-hover:underline" data-id="element-1054" data-mp="3cniy2t0siga7">
                    {step.label}
                  </Link>
                </h3>
              </li>)}
          </ul>
        </div>
      </section>
    </main>;
}